import React from "react";
import { TextLinkTemplate } from "./TextLinkTemplate.tsx";

export const LinkToAboutPage = () => {
  const leadText = "Can't see your favourite Cinema?";
  const linkText = "Request it here";
  const link = "about";

  return (
    <TextLinkTemplate
      leadText={leadText}
      linkText={linkText}
      href={link}
      appendHref={false}
    />
  );
};
